module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_3009.9d9197da.png";